import { template } from "lodash"
import { CREATE_MASTER_EMAIL_TEMPLATE, CREATE_MASTER_EMAIL_TEMPLATE_FAIL, CREATE_MASTER_EMAIL_TEMPLATE_SUCCESS, GET_CAMP_EMAIL_BY_ID, GET_CAMP_EMAIL_BY_ID_FAIL, GET_CAMP_EMAIL_BY_ID_SUCCESS, GET_CAMP_MASTER_TEMPLATE, GET_CAMP_MASTER_TEMPLATE_FAIL, GET_CAMP_MASTER_TEMPLATE_SUCCESS, GET_CUSTOM_EMAIL_TEMP_ID, GET_CUSTOM_EMAIL_TEMP_ID_FAIL, GET_CUSTOM_EMAIL_TEMP_ID_SUCCESS, GET_DRAFT_TEMPLATE, GET_DRAFT_TEMPLATE_FAIL, GET_DRAFT_TEMPLATE_SUCCESS, GET_MASTER_EMAIL_TEMPLATE, GET_MASTER_EMAIL_TEMPLATE_BY_ID, GET_MASTER_EMAIL_TEMPLATE_BY_ID_FAIL, GET_MASTER_EMAIL_TEMPLATE_BY_ID_SUCCESS, GET_MASTER_EMAIL_TEMPLATE_FAIL, GET_MASTER_EMAIL_TEMPLATE_SUCCESS, GET_MASTER_LANDING_PAGE_TEMPLATE, GET_MASTER_LANDING_PAGE_TEMPLATE_FAIL, GET_MASTER_LANDING_PAGE_TEMPLATE_SUCCESS, GET_TEMPLATES, GET_TEMPLATES_FAIL, GET_TEMPLATES_SUCCESS, GET_TEMPLATE_BY_ID, GET_TEMPLATE_BY_ID_FAIL, GET_TEMPLATE_BY_ID_SUCCESS, GET_TEMPLATE_BY_PROJECT_ID, GET_TEMPLATE_BY_PROJECT_ID_FAIL, GET_TEMPLATE_BY_PROJECT_ID_SUCCESS, GET_TEMPLATE_BY_TYPE, GET_TEMPLATE_BY_TYPE_FAIL, GET_TEMPLATE_BY_TYPE_SUCCESS, LOAD_INVITE_DATA_TEMPLATE, LOAD_INVITE_DATA_TEMPLATE_FAIL, LOAD_INVITE_DATA_TEMPLATE_SUCCESS, LOAD_MASTER_EMAIL_TEMPLATE, LOAD_MASTER_EMAIL_TEMPLATE_FAIL, LOAD_MASTER_EMAIL_TEMPLATE_SUCCESS, LOAD_MASTER_LANDINGPAGE_TEMPLATE, LOAD_MASTER_LANDINGPAGE_TEMPLATE_FAIL, LOAD_MASTER_LANDINGPAGE_TEMPLATE_SUCCESS, LOAD_PROJECT_EMAIL_TEMPLATE, LOAD_PROJECT_EMAIL_TEMPLATE_FAIL, LOAD_PROJECT_EMAIL_TEMPLATE_SUCCESS, LOAD_PROJECT_LANDING_TEMPLATE, LOAD_PROJECT_LANDING_TEMPLATE_FAIL, LOAD_PROJECT_LANDING_TEMPLATE_SUCCESS } from "./actionTypes"
  
  
  export const getAllTemplates = (agentId) => ({
    type: GET_TEMPLATES,
    agentId
  })
  
  export const getAllTemplatesSuccess = templates => ({
    type: GET_TEMPLATES_SUCCESS,
    payload: templates,
  })
  
  export const getAllTemplatesFail = error => ({
    type: GET_TEMPLATES_FAIL,
    payload: error,
  })



  export const getAllTemplateByType = (typeId,agentId) => ({
    type: GET_TEMPLATE_BY_TYPE,
    payload: { typeId, agentId }
  })
  
  export const getAllTemplateByTypeSuccess = typetemplates => ({
    type: GET_TEMPLATE_BY_TYPE_SUCCESS,
    payload: typetemplates,
  })
  
  export const getAllTemplateByTypeFail = error => ({
    type: GET_TEMPLATE_BY_TYPE_FAIL,
    payload: error,
  })


  export const getAllTemplateById = (id) => ({
    type: GET_TEMPLATE_BY_ID,
    id
  })
  
  export const getAllTemplateByIdSuccess = templateData => ({
    type: GET_TEMPLATE_BY_ID_SUCCESS,
    payload: templateData,
  })
  
  export const getAllTemplateByIdFail = error => ({
    type: GET_TEMPLATE_BY_ID_FAIL,
    payload: error,
  })


  export const getAllTemplateByProjectId = (projectid, templateid) => ({
    type: GET_TEMPLATE_BY_PROJECT_ID,
    payload:{projectid,templateid}
  })
  
  export const getAllTemplateByProjectIdSuccess = projectTempData => ({
    type: GET_TEMPLATE_BY_PROJECT_ID_SUCCESS,
    payload: projectTempData,
  })
  
  export const getAllTemplateByProjectIdFail = error => ({
    type: GET_TEMPLATE_BY_PROJECT_ID_FAIL,
    payload: error,
  })
  

  export const CreateNewMasterEmail = (template, history) => {
    return {
      type: CREATE_MASTER_EMAIL_TEMPLATE,
      payload: { template, history },
    }
  }
  
  export const CreateNewMasterEmailSuccess = template => {
    return {
      type: CREATE_MASTER_EMAIL_TEMPLATE_SUCCESS,
      payload: template,
    }
  }
  
  
  export const CreateNewMasterEmailSuccessError = error => {
    return {
      type: CREATE_MASTER_EMAIL_TEMPLATE_FAIL,
      payload: error,
    }
  }


  export const getMasterTemp = (agentId) => ({
    type: GET_MASTER_EMAIL_TEMPLATE,
    agentId
  })
  
  export const getMasterTempSuccess = templates => ({
    type: GET_MASTER_EMAIL_TEMPLATE_SUCCESS,
    payload: templates,
  })
  
  export const getMasterTempFail = error => ({
    type: GET_MASTER_EMAIL_TEMPLATE_FAIL,
    payload: error,
  })


  export const getTempById = (id) => ({
    type: GET_MASTER_EMAIL_TEMPLATE_BY_ID,
    id
  })
  
  export const getTempByIdSuccess = datatemp => ({
    type: GET_MASTER_EMAIL_TEMPLATE_BY_ID_SUCCESS,
    payload: datatemp,
  })
  
  export const getTempByIdFail = error => ({
    type: GET_MASTER_EMAIL_TEMPLATE_BY_ID_FAIL,
    payload: error,
  })

  export const loadEmailMasterTemplate = (projectId, templateId, agentId) => ({
    type: LOAD_MASTER_EMAIL_TEMPLATE,
    payload:{projectId, templateId, agentId}
  })
  
  export const loadEmailMasterTemplateSuccess = masterData => ({
    type: LOAD_MASTER_EMAIL_TEMPLATE_SUCCESS,
    payload: masterData,
  })
  
  export const loadEmailMasterTemplateFail = error => ({
    type: LOAD_MASTER_EMAIL_TEMPLATE_FAIL,
    payload: error,
  })
  

  export const getLandingPageMasterTemp = (agentId) => ({
    type: GET_MASTER_LANDING_PAGE_TEMPLATE,
    agentId
  })
  
  export const getLandingPageMasterTempSuccess = pagetemplates => ({
    type: GET_MASTER_LANDING_PAGE_TEMPLATE_SUCCESS,
    payload: pagetemplates,
  })
  
  export const getLandingPageMasterTempFail = error => ({
    type: GET_MASTER_LANDING_PAGE_TEMPLATE_FAIL,
    payload: error,
  })



  export const loadlandingMasterTemplate = (projectId, templateId, agentId) => ({
    type: LOAD_MASTER_LANDINGPAGE_TEMPLATE,
    payload:{projectId, templateId, agentId}
  })
  
  export const loadlandingMasterTemplateSuccess = landingMasterData => ({
    type: LOAD_MASTER_LANDINGPAGE_TEMPLATE_SUCCESS,
    payload: landingMasterData,
  })
  
  export const loadlandingMasterTemplateFail = error => ({
    type: LOAD_MASTER_LANDINGPAGE_TEMPLATE_FAIL,
    payload: error,
  })


  export const loadEventMasterTemplate = (eventId, templateId) => ({
    type: LOAD_INVITE_DATA_TEMPLATE,
    payload:{eventId, templateId}
  })
  
  export const loadEventMasterTemplateSuccess = eventMasterData => ({
    type: LOAD_INVITE_DATA_TEMPLATE_SUCCESS,
    payload: eventMasterData,
  })
  
  export const loadEventMasterTemplateFail = error => ({
    type: LOAD_INVITE_DATA_TEMPLATE_FAIL,
    payload: error,
  })

  export const getProjectLandingemplate = (id) => ({
    type: LOAD_PROJECT_LANDING_TEMPLATE,
    id
  })
  
  export const getProjectLandingemplateSuccess = projectlanding => ({
    type: LOAD_PROJECT_LANDING_TEMPLATE_SUCCESS,
    payload: projectlanding,
  })
  
  export const getProjectLandingemplateFail = error => ({
    type: LOAD_PROJECT_LANDING_TEMPLATE_FAIL,
    payload: error,
  })


   export const getDraftTemplate = (id) => ({
    type: GET_DRAFT_TEMPLATE,
    id
  })
  
  export const getDraftTemplateSuccess = templatedata => ({
    type: GET_DRAFT_TEMPLATE_SUCCESS,
    payload: templatedata,
  })
  
  export const getDraftTemplateFail = error => ({
    type: GET_DRAFT_TEMPLATE_FAIL,
    payload: error,
  })


   export const loadCampMasterTemplate = (templateId, agentId) => ({
    type: GET_CAMP_MASTER_TEMPLATE,
    payload:{templateId, agentId}
  })
  
  export const loadCampMasterTemplateSuccess = campmasterData => ({
    type: GET_CAMP_MASTER_TEMPLATE_SUCCESS,
    payload: campmasterData,
  })
  
  export const loadCampMasterTemplateFail = error => ({
    type: GET_CAMP_MASTER_TEMPLATE_FAIL,
    payload: error,
  })


    export const loadCampEmailData = (campId) => ({
    type: GET_CAMP_EMAIL_BY_ID,
    campId
  })
  
  export const loadCampEmailDataSuccess = campData => ({
    type: GET_CAMP_EMAIL_BY_ID_SUCCESS,
    payload: campData,
  })
  
  export const loadCampEmailDataFail = error => ({
    type: GET_CAMP_EMAIL_BY_ID_FAIL,
    payload: error,
  })


  export const getEmailCustomTemp = (id) => ({
    type: GET_CUSTOM_EMAIL_TEMP_ID,
    id
  })
  
  export const getEmailCustomTempSuccess = customTempData => ({
    type: GET_CUSTOM_EMAIL_TEMP_ID_SUCCESS,
    payload: customTempData,
  })
  
  export const getEmailCustomTempFail = error => ({
    type: GET_CUSTOM_EMAIL_TEMP_ID_FAIL,
    payload: error,
  })
